import { config } from 'api';
import errorHandler from 'utils/errorHandler';
import { setSuccessMessage } from 'apps/notifications/actions/notifications';

export const ADD_FEEDBACK_CORRECTION_TYPES = 'ADD_FEEDBACK_CORRECTION_TYPES';

export function addCorrectionTypes(correctionTypes) {
  return {
    type: ADD_FEEDBACK_CORRECTION_TYPES,
    correctionTypes,
  };
}

export function fetchFeedbackCorrectionTypes() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/products/feedback/correction-types`)
      .then(correctionTypes => dispatch(addCorrectionTypes(correctionTypes)))
      .catch(errorHandler);
}

export function postFeedback(feedbackData, sku) {
  return (dispatch, getState, { network }) =>
    network.post(
      `${config.apiBasePath}/products/${sku}/feedback`,
      {
        body: JSON.stringify(feedbackData),
      })
      .then(() =>
        dispatch(setSuccessMessage('Your message has been successfully submitted. Thank you.'))
      )
      .catch(errorHandler);
}
